import axios from "axios";
import getSign from "./signUtil.js";
import {Base64} from "../index.js" 
import Vue from "vue"
import { Modal } from 'ant-design-vue'
import store from '../../store/index'


  /**
 * param 将要转为URL参数字符串的对象
 * key URL参数字符串的前缀
 * encode true/false 是否进行URL编码,默认为true
 *
 * return URL参数字符串
 */
function urlEncode (param, key, encode) {
  if (param == null) return ''
  var paramStr = ''
  var t = typeof (param)
  if (t === 'string' || t === 'number' || t === 'boolean') {
    paramStr += '&' + key + '=' + ((encode == null || encode) ? encodeURIComponent(param) : param)
  } else {
    for (var i in param) {
      var k = key == null ? i : key + (param instanceof Array ? '[' + i + ']' : '.' + i)
      paramStr += urlEncode(param[i], k, encode)
    }
  }
  return paramStr
}
const instance = axios.create({
  timeout: 30 * 1000
});

instance.interceptors.request.use(function (config) {
  store.commit("setloading", true); //在请求发出之前进行一些操作
  return config
}, function (error) {
  return Promise.reject(error)
});
instance.interceptors.response.use(
  response => {
    store.commit("setloading", false); //在请求发出之前进行一些操作
    let { RETURN_CODE, RETURN_DESC } = response.data.RESPONSE;
    if (!["S000A000", "S0A00000","S1A00000"].includes(RETURN_CODE)) {
      // new Vue.prototype.$Dialog({
      //   title: "温馨提示",
      //   text: typeof RETURN_DESC === "string" ? RETURN_DESC : JSON.stringify(RETURN_DESC)
      // });
      Modal.error({
        title: '温馨提示',
        content: typeof RETURN_DESC === "string" ? RETURN_DESC : JSON.stringify(RETURN_DESC)
      })
      return Promise.reject(RETURN_DESC);
    }
    console.warn('是否响应',response.data.RESPONSE)

    return response.data.RESPONSE;
  },
  error => {
    // new Vue.prototype.$Dialog({
    //   title: "请求异常",
    //   text: typeof error === "string" ? error : JSON.stringify(error)
    // });
    
    Modal.error({
      title: '温馨提示',
      content: typeof error === "string" ? error : JSON.stringify(error)
    })
    return Promise.reject(error);
  }
);
class SSDPHelp {
  static User_Token = "";
  static Refresh_key = "";
  static Token_Expires = 0;
  static Refresh_Key_Expires = 0;
  constructor({
    App_Sub_ID,
    App_Token,
    App_Version,
    App_ID,
    App_key,
    Partner_ID,
    Divice_ID,
    Divice_Version,
    OS_Version
  } = {}) {
    this.App_Sub_ID = App_Sub_ID;
    this.App_Token = App_Token;
    this.App_key = App_key;
    this.App_Version = App_Version;
    this.App_ID = App_ID;
    this.Partner_ID = Partner_ID;
    this.Divice_ID = Divice_ID;
    this.Divice_Version = Divice_Version;
    this.OS_Version = OS_Version;
    this.API_ATTRS = {
      Api_ID: "crc.ssdp.public.apptoken",
      Api_Version: "1.0",
      App_ID: this.App_ID,
      //应用编码
      App_Sub_ID: this.App_Sub_ID,
      //授权令牌
      App_Token: this.App_Token,
      App_Version: this.App_Version,
      Divice_ID: this.Divice_ID,
      Divice_Version: this.Divice_Version,
      OS_Version: this.OS_Version,
      Partner_ID: this.Partner_ID,
      User_Token: SSDPHelp.User_Token
    };
  }
   request({ api, version, params } = {}) {
    this.API_ATTRS.Sign = getSign({...this.API_ATTRS,REQUEST_DATA:params,Time_Stamp: this.getTimeStamp(),}, this.App_key);
    // const encodeurl = `App_Sub_ID=${this.App_Sub_ID}&Api_ID=${api}&Api_Version=${version}`
    const encodeurl = `Api_ID=${api}&Api_Version=${version}&App_Sub_ID=${this.App_Sub_ID}&App_Token=${this.API_ATTRS.App_Token}&Partner_ID=K0000000&Sign=NO_SIGN&Sys_ID=K0000001&Time_Stamp=${this.getTimeStamp()}&User_Token=&App_ID=VTest&App_Version=V1.0.3&Divice_ID=diviceId&Divice_Version=diviceVersion&OS_Version=osVersion`
    console.log('普通接口base64加密前：' + encodeurl)
    let val = Base64.encode(encodeurl);
    console.log('普通接口base64加密后：' + val)
    console.log('更新后的app_token:' + this.API_ATTRS.App_Token)
    // return  instance.post(`/ssdp/app/rf/?ssdp=${val}${urlEncode(params)}`, {
    return  instance.post(`/ssdp/app/rs/?ssdp=${val}`, {
      REQUEST: {
        REQUEST_DATA: params,
        API_ATTRS: {
          ...this.API_ATTRS,
          Time_Stamp: this.getTimeStamp(),
          Api_ID: api,
          Api_Version: version,
          User_Token: SSDPHelp.User_Token
        }
      }
    });
  }
  async init() {
    this.API_ATTRS.App_Token = await this.FetchAccessToken();
  }
  //获取通信Token
  async FetchAccessToken() {
    
    let accessToken = sessionStorage.getItem(this.App_ID);
    if (accessToken) {
      return accessToken;
    }
    let Time_Stamp = this.getTimeStamp()
    let encodeurl = `Api_ID=crc.ssdp.public.apptoken&Api_Version=2.0&App_Sub_ID=K000000101LS&App_Token=1dbbd71b745e4e30b8e757b972adf216&Partner_ID=K0000000&Sign=MD5&Sys_ID=K0000001&Time_Stamp=${Time_Stamp}&User_Token=`
    // let encodeurl = `App_Sub_ID=${this.App_Sub_ID}&Api_ID=${this.API_ATTRS.Api_ID}&Api_Version=${this.API_ATTRS.Api_Version}`
    console.log('base64加密前：' + encodeurl)
    let val = Base64.encode(encodeurl);
    console.log('base64加密后：' + val)
    let res = await instance.post(`/ssdp/app/rs/?ssdp=${val}`, {
      REQUEST: {
        REQUEST_DATA: {
          App_key: this.App_key,
          App_Type: "",
          Scope: "",
          Remarks: ""
        },
        API_ATTRS: {
          ...this.API_ATTRS,
          Time_Stamp,
          Api_ID: "crc.ssdp.public.apptoken",
          Api_Version: "2.0",
          Sign: getSign({Time_Stamp,...this.API_ATTRS, Api_Version: "2.0",REQUEST_DATA: {
            App_key: this.App_key,
            App_Type: "",
            Scope: "",
            Remarks: ""
          }}, this.App_key)
        }
      }
    });
    let { RETURN_CODE, RETURN_DATA } = res;
    let { App_Token } = RETURN_DATA;
    localStorage.setItem(this.App_ID, App_Token);
    return App_Token;
  }

  getTimeStamp() {
    let Time_Stamp = new Date();
    return `${dateFormat(
      Time_Stamp,
      "yyyy-MM-dd hh:mm:ss"
    )}:${Time_Stamp.getMilliseconds()}`;
  }
}

function dateFormat(date = new Date(), fmt) {
  var o = {
    "M+": date.getMonth() + 1, //月份
    "d+": date.getDate(), //日
    "h+": date.getHours(), //小时
    "m+": date.getMinutes(), //分
    "s+": date.getSeconds(), //秒
    "q+": Math.floor((date.getMonth() + 3) / 3), //季度
    S: date.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
  return fmt;
}

export default SSDPHelp;
